

app.controller('DashboardHome', function ($scope, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $cookies, $translate) {
    $scope.login = {
        Username: '',
        Password: '',
        Email: '',
        Notelp: '',
        IsFinished: false
    };
  
    var allPromise = $q.all([
		$http({
		    method: 'POST',
		    url: '/service/client.svc/retrieveSession',
		}).then(function (data) {
		    if (!data.data.d) {
		        $http({
		            method: 'GET',
		            url: '/service/client.svc/SignOut',
		        }).then(function (data) {
		        }, function (error) { })
		    }
		    else
		        $scope.login = data.data.d;
		}, function (error) { }),

    ]);


    allPromise.then(function () {

    });
});
